import type { TNotesType } from "components/Dashboard/DoctorDashboard/notes-and-forms/types";
import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import getNoteOrFormSchemaDB from "./utils/getNoteOrFormSchemaDB";
import { parseRawTemplateResponse } from "notes-and-forms-v2/util/convertTemplateToV2";

/**
 *  Query schema
 */
export default async function querySchema<T extends TNotesType>({
  type,
  id,
  revision,
}: {
  type: T;
  id: number | string;
  revision?: number | string;
}): Promise<T extends "note" ? NoteSchema : FormSchema> {
  if (!type) {
    throw new Error("need note or form type");
  }
  const res = await fetchOrchidAPI(
    // need to check undefined or null, since 0 is considered falsy value
    `/api/${getNoteOrFormSchemaDB(type)}/v1/${type}s/schema/${id}${
      revision === undefined || revision === null
        ? ""
        : `?${type}_schema_revision=${revision}`
    }`,
  );

  if (!res.ok) {
    throw new Error(
      `failed to fetch schema: ${getErrorDetail(await res.text())}`,
    );
  }

  const raw = await res.json();

  return parseRawTemplateResponse(type, raw);
}
